import { render, staticRenderFns } from "./CleavageSite.vue?vue&type=template&id=a24404ce&scoped=true&"
import script from "./CleavageSite.vue?vue&type=script&lang=js&"
export * from "./CleavageSite.vue?vue&type=script&lang=js&"
import style0 from "./CleavageSite.vue?vue&type=style&index=0&id=a24404ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24404ce",
  null
  
)

export default component.exports